<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <!--程式功能清單維護程式-->
    <v-flex xs12>
        <!--{{countDownNo}}-->
        <v-card class="cardBgColorStyle">

            <v-card row wrap dark  color="secondary"  dense style="padding:0px 0px">

                <v-flex  d-inline-flex style="margin-bottom: -5px">
                    <v-btn @click="addItem"  dark fab top right color="accent" class="mb-2 mt-0">
                        <v-icon >mdi-plus</v-icon>
                    </v-btn>
                </v-flex>

                <!--程式名稱-->
                <v-flex d-inline-flex pl-2 style="font-size: 1.2rem;margin-bottom: -5px">
                    {{this.menuInfo.funTitle}}
                </v-flex>


                <v-flex xs12 sm6 md4 d-inline-flex>
                    <v-flex xs5 sm5 md5 text-right  class="labelFont">
                        <span style="color: white!important;">父層名稱</span>
                    </v-flex>
                    <v-flex xs7 sm7 md7 pl-2>
                        <v-autocomplete
                                v-model="parentId"
                                hide-details
                                :items="parentIdList"
                                item-text="funTitle"
                                item-value="funId"
                        ></v-autocomplete>
                    </v-flex>
                </v-flex>


                <!--<v-btn middle  icon dark fab  title="查詢" >-->
                <!--<v-icon >search</v-icon>-->
                <!--</v-btn>-->


                <v-flex xs12 sm6 md4 d-inline-flex pl-2>
                    <v-switch  class="mr-2"  style="float: right" hide-details  :label="`${effFlag==true?'有效資料':'全部資料'}`" v-model="effFlag"></v-switch>
                </v-flex>

            </v-card>



            <v-flex style="padding-top:1rem">
                <v-data-table
                        dense
                        :search="search"
                        id="funListTable"
                        :loading="funListLoading"
                        :headers="funListHeaders"
                        :items="filterFunList"
                        @page-count="pagination.pageCount = $event"
                        :page.sync="pagination.page"
                        :sort-by="pagination.sortBy"
                        :sort-desc="pagination.descending"
                        :loading-text="loadingText"
                        :items-per-page="pagination.rowsPerPage"
                        hide-default-footer
                        hide-default-header
                        item-key="chart_no"
                        v-resize="resizeFunListGrid"
                        class="elevation-1">

                    <template v-slot:header="{ props }">
                        <tr class="px-1 text-left tablehead">
                            <th v-for="header in props.headers"
                                :key="header.text"
                                :class="['column sortable',pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '','px-1']"
                                @click="changeSort(header.value)">
                                <span  v-html="header.text"></span>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'none' : 'inline' : 'none'}">
                                    mdi-arrow-up
                                </v-icon>
                                <v-icon small
                                        :style="{display:header.value === pagination.sortBy ? pagination.descending ? 'inline' : 'none' : 'none'}">
                                    mdi-arrow-down
                                </v-icon>
                            </th>
                        </tr>
                    </template>

                    <template slot="item" slot-scope="props" style="border: 1px solid black">
                        <!--<tr :active="props.selected" @click="props.selected = !props.selected">-->
                        <!--<td>
                          <v-checkbox :input-value="props.selected" primary hide-details></v-checkbox>
                        </td>-->
                        <tr>
                            <td class=" align-space-around justify-space-around fill-height px-0" >
                                <v-layout>
                                    <v-btn icon class="mx-0" @click.native.stop="editItem(props.item)"> <!---->
                                        <v-icon color="tertiary">mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn icon class="mx-0" @click.native.stop="deleteItem(props.item)"><!---->
                                        <v-icon color="tertiary">mdi-delete</v-icon>
                                    </v-btn>
                                </v-layout>

                            </td>
                            <td  class="px-1 text-left">{{ props.item.systemId}} ( {{ props.item.sortByNo}} )</td>
                            <td  class="px-1 text-left">{{ props.item.parentId}}</td>
                            <td  class="px-1 text-left">{{ props.item.funId}}</td>
                            <td  class="px-1 text-left">{{ props.item.funTitle}}</td>
                            <td  class="px-1 text-left">{{ props.item.zoneList}}</td>
                            <td  class="px-1 text-left">{{ props.item.effFlag}}</td>



                        </tr>
                    </template>
                    <template slot="pageText" slot-scope="props">
                        第 {{ props.pageStart }} - {{ props.pageStop }} ,共 {{ props.itemsLength }} 筆
                    </template>
                    <template slot="no-data">

                        <v-alert :value='countDownNo>=5' type="warning" icon="mdi-alert-circle">
                            查詢中...
                        </v-alert>
                        <v-alert :value='tableAlert' color="info" icon="mdi-information">
                            表格中沒有內容
                        </v-alert>

                    </template>
                    <!--<v-alert slot="no-results" :value="true" color="info" icon="mdi-alert-circle">-->
                    <!--Your search for " {{ search }} " found no results.-->
                    <!--</v-alert>-->
                </v-data-table>
                <v-layout row wrap>
                    <v-flex xs12 md2>
                        <v-text-field
                                v-model="search"
                                class="ml-2 mt-2"
                                prepend-inner-icon="mdi-magnify"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-flex>


                    <v-flex xs12 md6 text-center pt-2>
                        <v-pagination color="accent" v-model="pagination.page" :length="pagination.pageCount" :total-visible="7"></v-pagination>
                    </v-flex>
                    <v-flex xs6 md2 pt-2 pr-2 pl-2>
                        <v-select
                                :items="pageItem"
                                label="每頁筆數"
                                item-value="value"
                                v-model="pagination.rowsPerPage"
                        ></v-select>
                    </v-flex>
                    <v-flex xs6 md2 text-left pt-2 pr-2>
                        <v-text-field
                                label="總筆數"
                                v-model="filterFunList.length"
                                readonly
                        ></v-text-field>
                    </v-flex>
                </v-layout>

            </v-flex>



        </v-card>

        <v-dialog v-model="editDialog"
                  eager
                  xs6 sm6 md6
                  :width="editDialogWidth+'%'"
                  value="false"
                  scrollable>
            <edit-fun-info  :system-id-list="funSysList" :is-show="editDialog" @closeDialog="closeDialog" @save="save" :edit-index="editIndex" :edit-obj="editObj"></edit-fun-info>
        </v-dialog>

        <v-dialog v-model="deleteDialog"
                  width="50%"
                  xs6 sm6 md6
                  value="false"
                  scrollable>
            <delete-info-dialog @closeDelete="closeDelete" @confirmDelete="confirmDelete" :delete-title="deleteTitle" :delete-content="deleteContent"></delete-info-dialog>
        </v-dialog>

        <!-- 我是 snackbar -->
        <v-snackbar
                :timeout="snTimeout"
                v-model="snStatus">
            {{snText}}
        </v-snackbar>


    </v-flex>
</template>

<script>
    import DeleteInfoDialog from './DeleteInfoDialog'
    import EditFunInfo from './EditFunInfo'
    export default {
        name: "FunListMaintain",
        components: {EditFunInfo, DeleteInfoDialog},
        data() {
            return {
                //程式功能清單
                countDownId: null, //data 定義一個定時器id
                countDownNo:0,
                tableAlert:false,
                effFlag:true,
                funListLoading:false,
                loadingText:'查詢中...',
                search:'',
                snTimeout:4000,
                snStatus:false,
                snText:'',
                deleteDialog:false,
                deleteTitle:'刪除 程式清單',
                deleteContent:'',
                deleteObj:{},
                editDialog:false,
                editIndex:-1,
                editObj:{},
                funListData: [],
                funSysList:[],
                parentIdList:[],
                systemId:'',
                parentId:'',
                pagination: {
                    sortBy: 'dataType',
                    rowsPerPage:100,
                    page: 1,
                    pageCount: 0,
                    descending:false
                },
                pageItem:[
                    {text:100,value:100},
                    {text:20,value:20},
                    {text:"All",value:-1},
                ],
                pageText:'每頁筆數 :',
                funListHeaders:[
                    {
                        text: '',
                        align: 'center',
                        // value: 'assessDate'
                    },
                    {
                        text: '系統名稱 (序)',
                        // align: 'left',
                        value: 'systemId',
                        class:'px-1'
                    },
                    {
                        text: '父層代號',
                        // align: 'center',
                        value: 'parentId',
                        class:'px-1'
                    },
                    {
                        text: '功能代號',
                        // align: 'center',
                        value: 'funId',
                        class:'px-1'
                    },
                    {
                        text: '功能名稱',
                        // align: 'center',
                        value: 'funTitle',
                        class:'px-1'
                    },
                    {
                        text: '院區清單',
                        // align: 'center',
                        value: 'zoneList',
                        class:'px-1'
                    },
                    {
                        text: '有效',
                        // align: 'left',
                        value: 'effFlag',
                        class:'px-1'
                    },

                ]
            }
        },
        created(){
            this.axios_getFunListData(); // 取得程式功能清單
            // this.axios_getFunSysIdList();//取得程式系統清單
            this.axios_getParentIdList();//取得程式功能父層清單

        },
        computed:{
            filterFunList:function() { // 110/08/20 修改
                let msgY = ['Y','U','M'];//有效
                let msgN = ['Y','N','U','M'];//全部
                let msgFlag = this.effFlag == true ? msgY : msgN;

                return this.funListData.filter((item) => {
                    let finalArr = [];

                    let systemId = item.systemId ==undefined?'':item.systemId;
                    let parentId = item.parentId ==undefined?'':item.parentId;

                    let temp1 = systemId.includes(this.systemId);
                    let temp2 = parentId.includes(this.parentId);

                    // dropdown list
                    msgFlag.filter((drpItem) => {
                        finalArr.push(item.effFlag == drpItem);
                    });

                    let flag = temp2 && temp1  && finalArr.some(function (value) {
                        return value == true;
                    });

                    return flag;
                });
            },

            menuInfo() {
                return this.$store.state.menuInfo;
            },

            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 50;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  76}
                if(this.$vuetify.breakpoint.lg == true){width =  80}
                if(this.$vuetify.breakpoint.xl ==true){width =  80}
                return width
            },
        },
        watch:{
        },
        methods:{
            parentIdItemText: item => item.funId==''?'':item.funId + ' : ' + item.funTitle, //格式化 autocomplete 選權限顯示文字
            countDown(){
                if(this.countDownId != null ) return;
                this.countDownId = setInterval(() => {
                    this.countDownNo++
                },1000)
            },
            //停止計時器
            stopCountDown(){
                clearInterval(this.countDownId);
                //當我清除定時器之後，重新讓countDownId為null , countDownNo歸零
                this.countDownId = null;
                this.countDownNo=0;
            },
            changeSort: function(column) {
                // console.log(column);
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false
                }
            },
            closeDelete(){
                this.deleteDialog = false;

            },
            confirmDelete(){
                this.axios_deleteDatasetInfo(this.deleteObj);
            },
            transformUTC(utc,flag){ //uct->Date ; flag-> all,date,time
                let date =  this.$UtilityJs.AD2ROC_DateTime(utc,flag);
                return (date)
            },
            addItem(){  //新增按鈕
                this.editDialog = true;
                this.editIndex = -1;
            },
            closeDialog(){ //關閉編輯視窗
                this.editDialog = false;
            },
            editItem:function(item){
                this.editIndex = this.filterFunList.indexOf(item);
                this.editObj = item;
                this.editDialog = true;
            },
            deleteItem:function(item){  //刪除
                this.deleteObj = item;
                this.deleteDialog = true;
                // this.deleteContent = '確定要刪除 '+item.systemId+" 父層為 "+item.parentId+" <br/>功能代號為 "+item.funId +"的 "+item.funTitle;
                this.deleteContent = '確定要刪除，[系統名稱 '+item.systemId+" / 功能代號"+item.funId+" / 功能名稱"+item.funTitle+"]記錄";
            },
            save(item){
                if(this.editIndex==-1){ //新增
                    this.axios_postFunList(item);
                }else { //修改
                    this.axios_putFunList(item);
                }
            },
            resizeFunListGrid:function(){
                var userHeight = window.innerHeight
                    || document.documentElement.clientHeight
                    || document.body.clientHeight;
                let height = userHeight-(270);
                let funListTable = document.getElementById('funListTable');
                funListTable.setAttribute('style','overflow-y: auto;min-height:'+height+'px;max-height:'+height+'px;');
            },
            axios_getFunListData (){ //程式功能清單
                this.countDown();//開始計時
                this.funListLoading = true;
                this.tableAlert = false;
                this.funListData = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "funlist";


                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.funListData = response.data.resultSet;
                    }else{
                        this.tableAlert = true;
                        this.funListData = [];
                    }
                    this.funListLoading = false;
                    this.stopCountDown();
                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.funListData = [];
                    } catch(err) {
                        this.funListData = [];
                    }
                    this.stopCountDown();
                });
            },
            axios_getFunSysIdList (){ //系統清單

                this.funSysList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "funlist/sys";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.funSysList = response.data.resultSet;
                        this.funSysList.unshift({
                            key:'',
                            value:'',
                        })
                    }else{
                        this.funSysList = [];
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.funSysList = [];
                    } catch(err) {
                        this.funSysList = [];
                    }
                });
            },
            axios_getParentIdList (){ //取得程式功能父層清單

                this.parentIdList = [];
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "funlist/header";

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.parentIdList = response.data.resultSet;
                        this.parentIdList.unshift({
                            funId:'',
                            funTitle:'',
                        })
                    }else{
                        this.parentIdList = [];
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.funSysList = [];
                    } catch(err) {
                        this.funSysList = [];
                    }
                });
            },
            axios_postFunList(postData){ //新增 程式功能
                let postList = [];
                postList.push(postData);
                let url = this.$store.state.AppSetting.backSrvUrl+'funlist/';

                this.$http.post(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0&& response.data.hasOwnProperty('resultSet')){
                        this.editDialog = false;
                        this.axios_getFunListData();


                        // this.search = response.data.resultSet[0].dataType
                    }
                    this.snText = response.data.message;
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_putFunList(putData){ //修改 程式功能
                let postList = [];
                postList.push(putData);
                let url = this.$store.state.AppSetting.backSrvUrl+'funlist/';

                this.$http.put(url,postList).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.editDialog = false;
                        this.axios_getFunListData();

                        // this.search = response.data.resultSet[0].dataType

                    }
                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },
            axios_deleteDatasetInfo(item){   //刪除單筆資料
                let url =this.$store.state.AppSetting.backSrvUrl +'funlist/s/'+item.funId;
                this.$http.delete(url).then(response=>{
                    this.snStatus=true;
                    this.snText = response.data.message;
                    if(response.data.resultSet.length>0){
                        this.axios_getFunListData();
                        this.deleteDialog = false;
                    }

                }).catch(error =>{
                    try{
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }catch (e) {
                        this.snStatus=true;
                        this.snText = error.response.data.message;
                    }
                });
            },

        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>